export const VIEW_DETAILS = 'View Details';
export const SELECT_A_COMPANY_TO_SWITCH = 'Select a company to switch:';
export const LOG_OUT = 'Log Out';

export const REPORT_DATE = 'Report Date';
export const VIEW_PREVIOUS_REPORTS = 'View Previous Reports';
